import * as Logger from 'loglevel';

if (process.env.APP_DEBUG === true) {
  Logger.setLevel('DEBUG');
  Logger.debug('Logger set to DEBUG');
} else {
  Logger.setLevel('INFO');
}

export default Logger;
